import 'bootstrap'; // Import Bootstrap's JavaScript
import $ from 'jquery';

// Modules
// Shared
import '/src/js/modules/list-transition';
import '/src/js/modules/accordion';
import '/src/js/modules/search';

// Components
import '/src/js/modules/navbar';
import '/src/js/modules/cookie';
import '/src/js/modules/hero';
import '/src/js/modules/line-up';
import '/src/js/modules/header/header';
import '/src/js/modules/highlights/highlights';
import '/src/js/modules/newsletter';
import '/src/js/modules/splash-logo';
import '/src/js/modules/simple-slider';



import '/src/js/modules/dumbar-components/text_transition';
import '/src/js/modules/dumbar-components/title_animation';
import '/src/js/modules/title-animation-extension';


window.onload = function() {
    document.getElementById('header').focus();
};


Array
    .from(document.querySelectorAll('video'))
    .filter(el => getComputedStyle(el).display !== 'none')
    .forEach(el => el.play());